import { useTranslation } from "react-i18next";
import { BrandMark } from "./brand-mark";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { SectionSwitcher } from "./section-switcher";
import { ConnectionPill } from "./connection-pill";
import { cn } from "@/lib/utils";
import type { AppSection } from "@/lib/app-sidebar";

export interface MobileTopbarProps {
  variant: "worker" | "admin";
  user: { firstName: string; lastName: string };
  section?: AppSection;
  canSwitchSection?: boolean;
  sectionSwitcherTargetLabel?: string;
  onAvatarClick?: () => void;
  hidden?: boolean;
}

export function MobileTopbar({
  variant,
  user,
  section,
  canSwitchSection,
  sectionSwitcherTargetLabel,
  onAvatarClick,
  hidden,
}: MobileTopbarProps) {
  const { t } = useTranslation();
  return (
    <header
      style={{ viewTransitionName: "vroom-topbar" }}
      className={cn(
        "flex h-[50px] items-center justify-between gap-3 border-b border-line bg-surface px-3",
        "transition-transform duration-200 ease-out",
        hidden ? "-translate-y-full" : "translate-y-0",
        "pt-[env(safe-area-inset-top)]",
        "[view-transition-name:vroom-topbar]",
      )}
    >
      <div className="flex items-center gap-2">
        <BrandMark />
        {variant === "worker" ? (
          <span className="font-semibold text-ink-900">{t("common.brand.label")}</span>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        {variant === "worker" ? <ConnectionPill /> : null}
        {canSwitchSection && section ? (
          <SectionSwitcher
            section={section}
            size="compact"
            targetLabel={sectionSwitcherTargetLabel}
          />
        ) : null}
        <button
          type="button"
          aria-label={t("common.nav.profile.label")}
          onClick={onAvatarClick}
          className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p-600"
        >
          <Avatar className="size-9">
            <AvatarFallback initials={`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`} />
          </Avatar>
        </button>
      </div>
    </header>
  );
}
